import { MobileIdNewContent } from '../../../../../components/MobileId/MobileIdNew.js';
import { useLoaderData } from 'react-router-dom';
import type { Contract } from '../../../../../generated/api/contract';

export const MobileIdNewPath = () => {
  const mobileIdContracts = useLoaderData() as Contract[];
  return <MobileIdNewContent mobileIdContracts={mobileIdContracts} />;
};
